import axios from "axios";

function findSimilarJobs(data, setResults) {
  axios
    .post("/api/findsimilarjobs", {
      data: data
    })
    .then(res => {
      let results = res.data.data[0];
      setResults(results);
    })
    .catch(err => {
      console.log("I HAVE ERRORED: ", err);
    });
}

export { findSimilarJobs };



// WEBPACK FOOTER //
// ./src/actions/Careers/findSimilarJobs.js